import React, { useEffect, useState } from "react";
import blue_drop_down from "../../../assets/images/blue_dropdown_arrow.png";
import blue_right_arrow from "../../../assets/images/RightArrow@2x.png";
import { useTranslation } from "react-i18next";
import { useKeyDown } from "../../../hooks/useKeyDown";
import { useDispatch, useSelector } from "react-redux";
import Agreements from "../Agreements";
import { useNavigate } from "react-router";
import logFirebaseEvents from "../../LogFirebaseEvents";
import { appTheme } from "../../../helpers/utils/Utils";

const HtmlNavigation = ({ agreementType, isSMIOne, isKudzu }) => {
  const { t } = useTranslation(); // Hook to access translation functions
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);

  const { name, url } = agreementType;
  const cards = useSelector((state) => JSON.parse(state.userCards));

  useEffect(() => {}, []);

  const handleNavigation = () => {
    debugger;
    dispatch({
      type: "UPDATE_AGREEMENT_TYPE",
      payload: { documentAgreementType: agreementType },
    });
    if(url === "about_us"){
      window.open("https://www.smionecard.com", "_blank");
      return;
    }
    if (url === "Fees") { navigate('/Documents/smiONE/Policies/Fees')
      return;
     }
    else { navigate(`/Documents/Policies/${name}`) }
    if (isSMIOne !== undefined || isKudzu !== undefined) {
      debugger;
      if (isSMIOne === true) {
        navigate(`/Documents/smiONE/Policies/${name}`);
      }

      if (isKudzu === true) {
        navigate(`/Documents/Kudzu/Policies/${name}`);
      }
    } else {
      navigate(`/Documents/Policies/${name}`);
    }
    logFirebaseEvents(
      "Policies",
      name.replace(/ /g, "_"),
      name.replace(/ /g, "_"),
      "",
      ""
    );
  };

  useKeyDown(() => {}, ["Enter"]);

  return (
    <>
      <button className="w-full md:my-5 my-0" onClick={handleNavigation}>
        <div>
          <div className="flex justify-between flex-row items-center w-full my-5">
            <p className="sm:font-[700] font-[600] font-hanken-grotesk  md:text-[16px] sm:text-[11px] text-[16px] leading-[24px] sm:leading-[14px] mr-3 text-left text-[var(--html-text-clr)]">
              {name || "Select"}
            </p>
            <img
              src={appThemeData.kudzu_arrow_to}
              className="w-3 h-3 mr-2 ml-12"
              alt=""
            />
          </div>

          <div className="bg-[var(--html-border-clr)] h-0.5  mt-5 mb-[-15px] md:mt-10 mx-auto"></div>
        </div>
      </button>
      {/* {isOpen && (
                <div className='mt-5'>
                    <Agreements type={props.type} linkClickAction={props.linkClickAction} isFromEsignAccept={false} />
                </div>
            )} */}
    </>
  );
};

export default HtmlNavigation;
